export default __webpack_public_path__ + "static/media/plywood.1099aa59.webp";